import { useEffect, useState } from 'react';

// Types
import { IAoyAnglerRank } from '../types';

// Util
import * as api from '../util/api';
import { refreshRate } from './../util/util';

const AOY_FETCH_RATE = refreshRate([60000, 60000]);
const aoyApi = '/wp-json/data/v1/tournament/angler-of-the-year';

// Hook will return the AOY standings or just the AOY standing for an angler
const useAoyStandings = (tid: number) => {
  const [aoyStandings, setAoyStandings] = useState<IAoyAnglerRank[]>([]);

  useEffect(() => {
    /**
     * Set state for the AOY standings when api returns.
     * NOTE: *returns a function to capture scope*
     */
    const storeAoyStandings = () => (response: IAoyAnglerRank[]) => {
      setAoyStandings(response);
    };

    (async () => {
      await api.subscribe({
        callback: storeAoyStandings(),
        rate: AOY_FETCH_RATE,
        uri: `${aoyApi}?tournament_id=${tid}`,
      });
    })();
  }, [tid]);

  return aoyStandings;
};

export default useAoyStandings;
